import t, { useState as e, useMemo as n, Fragment as o } from "react";
import r from "prop-types";
import { Transition as i } from "react-transition-group";
import { css as a, cx as c } from "@leafygreen-ui/emotion";
import l from "@leafygreen-ui/portal";
import { usePopoverPortalContainer as s } from "@leafygreen-ui/leafygreen-provider";
import { useViewportSize as u, useMutationObserver as f, useObjectDependency as p, usePrevious as d, useIsomorphicLayoutEffect as h } from "@leafygreen-ui/hooks";
import { consoleOnce as g } from "@leafygreen-ui/lib";
import { jsx as m } from "@emotion/react";
function w(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function y(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? w(Object(n), !0).forEach(function (e) {
      v(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : w(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
function v(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function b() {
  return b = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, b.apply(this, arguments);
}
function P(t, e) {
  if (null == t) return {};
  var n,
    o,
    r = function (t, e) {
      if (null == t) return {};
      var n,
        o,
        r = {},
        i = Object.keys(t);
      for (o = 0; o < i.length; o++) n = i[o], e.indexOf(n) >= 0 || (r[n] = t[n]);
      return r;
    }(t, e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (o = 0; o < i.length; o++) n = i[o], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function E(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
function j(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == n) return;
    var o,
      r,
      i = [],
      a = !0,
      c = !1;
    try {
      for (n = n.call(t); !(a = (o = n.next()).done) && (i.push(o.value), !e || i.length !== e); a = !0);
    } catch (t) {
      c = !0, r = t;
    } finally {
      try {
        a || null == n.return || n.return();
      } finally {
        if (c) throw r;
      }
    }
    return i;
  }(t, e) || C(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function O(t) {
  return function (t) {
    if (Array.isArray(t)) return S(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
  }(t) || C(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function C(t, e) {
  if (t) {
    if ("string" == typeof t) return S(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? S(t, e) : void 0;
  }
}
function S(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var n = 0, o = new Array(e); n < e; n++) o[n] = t[n];
  return o;
}
var x,
  D,
  H,
  R,
  V,
  T,
  B,
  M,
  W = {
    Top: "top",
    Bottom: "bottom",
    Left: "left",
    Right: "right",
    CenterVertical: "center-vertical",
    CenterHorizontal: "center-horizontal"
  },
  F = {
    Start: "start",
    Middle: "middle",
    End: "end",
    Fit: "fit"
  };
function L(t) {
  var e = t.useRelativePositioning,
    n = t.spacing,
    o = t.align,
    r = t.justify,
    i = t.referenceElViewportPos,
    a = void 0 === i ? z : i,
    c = t.referenceElDocumentPos,
    l = void 0 === c ? z : c,
    s = t.contentElViewportPos,
    u = void 0 === s ? z : s,
    f = t.contentElDocumentPos,
    p = void 0 === f ? z : f,
    d = t.scrollContainer,
    h = t.windowHeight,
    g = void 0 === h ? window.innerHeight : h,
    m = t.windowWidth,
    w = void 0 === m ? window.innerWidth : m,
    v = d ? d.offsetWidth : w,
    b = d ? d.offsetHeight : g,
    P = {
      windowWidth: v,
      windowHeight: b,
      referenceElViewportPos: a,
      contentElViewportPos: u,
      spacing: n
    };
  if (0 === u.width && r !== F.Fit) return {
    align: o,
    justify: r,
    positionCSS: {
      left: 0,
      top: 0
    }
  };
  var E = function (t, e) {
      var n = e.spacing,
        o = e.windowWidth,
        r = e.windowHeight,
        i = e.contentElViewportPos,
        a = e.referenceElViewportPos;
      return [t].concat(O(tt[t])).find(function (t) {
        return [W.Top, W.Bottom, W.CenterVertical].includes(t) ? _({
          top: J({
            align: t,
            contentElPos: i,
            referenceElPos: a,
            spacing: n
          }),
          windowHeight: r,
          contentHeight: i.height
        }) : !![W.Left, W.Right, W.CenterHorizontal].includes(t) && Q({
          left: K({
            align: t,
            contentElPos: i,
            referenceElPos: a,
            spacing: n
          }),
          windowWidth: o,
          contentWidth: i.width
        });
      }) || t;
    }(o, P),
    j = function (t, e, n) {
      var o,
        r,
        i = n.spacing,
        a = n.windowWidth,
        c = n.windowHeight,
        l = n.contentElViewportPos,
        s = n.referenceElViewportPos,
        u = [t].concat(O(et[t]));
      switch (e) {
        case W.Top:
        case W.Bottom:
        case W.CenterVertical:
          return null !== (o = u.find(function (t) {
            return Q({
              contentWidth: t === F.Fit ? s.width : l.width,
              windowWidth: a,
              left: K({
                contentElPos: l,
                referenceElPos: s,
                spacing: i,
                align: e,
                justify: t
              })
            });
          })) && void 0 !== o ? o : et[t][0];
        case W.Left:
        case W.Right:
        case W.CenterHorizontal:
          return null !== (r = u.find(function (t) {
            return _({
              contentHeight: t === F.Fit ? s.height : l.height,
              windowHeight: c,
              top: J({
                contentElPos: l,
                referenceElPos: s,
                spacing: i,
                align: e,
                justify: t
              })
            });
          })) && void 0 !== r ? r : et[t][0];
      }
    }(r, E, P),
    C = function (t) {
      var e,
        n,
        o = t.align,
        r = t.justify,
        i = U[o],
        a = null !== (e = i.x) && void 0 !== e ? e : Z[r],
        c = null !== (n = i.y) && void 0 !== n ? n : k[r];
      return "".concat(a, " ").concat(c);
    }({
      align: E,
      justify: j
    }),
    S = function (t, e) {
      var n = .8;
      switch (t) {
        case W.Top:
          return "translate3d(0, ".concat(e, "px, 0) scale(").concat(n, ")");
        case W.Bottom:
          return "translate3d(0, -".concat(e, "px, 0) scale(").concat(n, ")");
        case W.Left:
          return "translate3d(".concat(e, "px, 0, 0) scale(").concat(n, ")");
        case W.Right:
          return "translate3d(-".concat(e, "px, 0, 0) scale(").concat(n, ")");
        case W.CenterHorizontal:
        case W.CenterVertical:
          return "scale(".concat(n, ")");
      }
    }(E, n);
  return e ? {
    align: E,
    justify: j,
    positionCSS: y(y({}, q({
      align: E,
      justify: j,
      referenceElDocumentPos: l,
      contentElDocumentPos: p,
      spacing: n
    })), {}, {
      transformOrigin: C,
      transform: S
    })
  } : {
    align: E,
    justify: j,
    positionCSS: y(y({}, G({
      align: E,
      justify: j,
      referenceElDocumentPos: l,
      contentElDocumentPos: p,
      spacing: n,
      windowHeight: b,
      windowWidth: v
    })), {}, {
      transformOrigin: C,
      transform: S
    })
  };
}
var z = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: 0,
    width: 0
  },
  N = function (t, e) {
    return Math.abs(t - e) < 1 ? t : e;
  };
function A(t, e) {
  if (!t) return z;
  var n = t.getBoundingClientRect(),
    o = n.top,
    r = n.bottom,
    i = n.left,
    a = n.right,
    c = n.width,
    l = t.offsetHeight,
    s = t.offsetWidth,
    u = N(c, s);
  if (e) {
    var f = e.scrollTop,
      p = e.scrollLeft,
      d = e.getBoundingClientRect();
    return {
      top: o + f - d.top,
      bottom: r + f - d.bottom,
      left: i + p - d.left,
      right: a + p - d.right,
      height: l,
      width: u
    };
  }
  var h = window,
    g = h.scrollX,
    m = h.scrollY;
  return {
    top: o + m,
    bottom: r + m,
    left: i + g,
    right: a + g,
    height: l,
    width: u
  };
}
function I(t, e) {
  if (!t) return z;
  var n = t.getBoundingClientRect(),
    o = n.top,
    r = n.bottom,
    i = n.left,
    a = n.right,
    c = n.width,
    l = t.offsetHeight,
    s = t.offsetWidth,
    u = N(c, s);
  if (e) {
    var f = e.getBoundingClientRect();
    return {
      top: o - f.top,
      bottom: r - f.bottom,
      left: i - f.left,
      right: a - f.right,
      height: l,
      width: u
    };
  }
  return {
    top: o,
    bottom: r,
    left: i,
    right: a,
    height: l,
    width: u
  };
}
var k = (v(x = {}, F.Start, "top"), v(x, F.Middle, "center"), v(x, F.End, "bottom"), v(x, F.Fit, "center"), x),
  Z = (v(D = {}, F.Start, "left"), v(D, F.Middle, "center"), v(D, F.End, "right"), v(D, F.Fit, "center"), D),
  U = (v(H = {}, W.Left, {
    x: "right"
  }), v(H, W.Right, {
    x: "left"
  }), v(H, W.Top, {
    y: "bottom"
  }), v(H, W.Bottom, {
    y: "top"
  }), v(H, W.CenterHorizontal, {
    x: "center"
  }), v(H, W.CenterVertical, {
    y: "center"
  }), H);
var X = (v(R = {}, F.Start, {
    top: 0
  }), v(R, F.End, {
    bottom: 0
  }), v(R, F.Middle, function (t) {
    var e = t.contentElDocumentPos,
      n = t.referenceElDocumentPos;
    return {
      top: "".concat(n.height / 2 - e.height / 2, "px")
    };
  }), v(R, F.Fit, {
    top: 0,
    bottom: 0
  }), R),
  Y = (v(V = {}, F.Start, {
    left: 0
  }), v(V, F.End, {
    right: 0
  }), v(V, F.Middle, function (t) {
    var e = t.contentElDocumentPos,
      n = t.referenceElDocumentPos;
    return {
      left: "".concat(n.width / 2 - e.width / 2, "px")
    };
  }), v(V, F.Fit, {
    left: 0,
    right: 0
  }), V),
  $ = (v(T = {}, W.Top, {
    constant: function (t) {
      var e = t.spacing;
      return {
        bottom: "calc(100% + ".concat(e, "px)")
      };
    },
    justifyPositions: Y
  }), v(T, W.Bottom, {
    constant: function (t) {
      var e = t.spacing;
      return {
        top: "calc(100% + ".concat(e, "px)")
      };
    },
    justifyPositions: Y
  }), v(T, W.CenterVertical, {
    constant: function (t) {
      var e = t.referenceElDocumentPos;
      return {
        top: "calc(".concat(e.height / 2, "px - 50%)")
      };
    },
    justifyPositions: Y
  }), v(T, W.Left, {
    constant: function (t) {
      var e = t.spacing;
      return {
        right: "calc(100% + ".concat(e, "px)")
      };
    },
    justifyPositions: X
  }), v(T, W.Right, {
    constant: function (t) {
      var e = t.spacing;
      return {
        left: "calc(100% + ".concat(e, "px)")
      };
    },
    justifyPositions: X
  }), v(T, W.CenterHorizontal, {
    constant: function (t) {
      var e = t.referenceElDocumentPos;
      return {
        left: "calc(".concat(e.width / 2, "px - 50%)")
      };
    },
    justifyPositions: X
  }), T);
function q(t) {
  var e,
    n = t.align,
    o = t.justify,
    r = t.referenceElDocumentPos,
    i = t.contentElDocumentPos,
    a = t.spacing,
    c = $[n],
    l = c.justifyPositions[o],
    s = {
      contentElDocumentPos: i,
      referenceElDocumentPos: r,
      spacing: a
    };
  return y(y({}, null === (e = c.constant) || void 0 === e ? void 0 : e.call(c, s)), "function" == typeof l ? l(s) : l);
}
function G(t) {
  var e = t.align,
    n = t.justify,
    o = t.referenceElDocumentPos,
    r = t.contentElDocumentPos,
    i = t.spacing,
    a = t.windowWidth,
    c = t.windowHeight,
    l = K({
      align: e,
      justify: n,
      referenceElPos: o,
      contentElPos: r,
      spacing: i
    }),
    s = "".concat(l, "px"),
    u = "".concat(J({
      align: e,
      justify: n,
      referenceElPos: o,
      contentElPos: r,
      spacing: i
    }), "px");
  return n !== F.Fit ? {
    left: s,
    top: u
  } : [W.Left, W.Right, W.CenterHorizontal].includes(e) ? {
    left: s,
    top: u,
    bottom: "".concat(c - o.bottom, "px")
  } : {
    left: s,
    top: u,
    right: "".concat(a - (l + o.width), "px")
  };
}
function J(t) {
  var e = t.align,
    n = t.justify,
    o = t.contentElPos,
    r = t.referenceElPos,
    i = t.spacing;
  switch (e) {
    case W.Left:
    case W.Right:
    case W.CenterHorizontal:
      switch (n) {
        case F.Start:
        case F.Fit:
          return r.top;
        case F.End:
          return r.top + r.height - o.height;
        default:
          return r.top - (o.height - r.height) / 2;
      }
    case W.CenterVertical:
      return r.top - (o.height - r.height) / 2;
    case W.Top:
      return r.top - o.height - i;
    case W.Bottom:
    default:
      return r.top + r.height + i;
  }
}
function K(t) {
  var e = t.align,
    n = t.justify,
    o = t.contentElPos,
    r = t.referenceElPos,
    i = t.spacing;
  switch (e) {
    case W.Top:
    case W.Bottom:
    case W.CenterVertical:
      switch (n) {
        case F.End:
          return r.left + r.width - o.width;
        case F.Middle:
          return r.left - (o.width - r.width) / 2;
        default:
          return r.left;
      }
    case W.Left:
      return r.left - o.width - i;
    case W.Right:
      return r.left + r.width + i;
    case W.CenterHorizontal:
    default:
      return r.left - (o.width - r.width) / 2;
  }
}
function Q(t) {
  var e = t.left,
    n = t.windowWidth,
    o = t.contentWidth;
  return e >= 0 && !(e + o > n);
}
function _(t) {
  var e = t.top,
    n = t.windowHeight,
    o = t.contentHeight;
  return e >= 0 && !(e + o > n);
}
var tt = (v(B = {}, W.Top, [W.Bottom]), v(B, W.Bottom, [W.Top]), v(B, W.Left, [W.Right]), v(B, W.Right, [W.Left]), v(B, W.CenterHorizontal, [W.Left, W.Right]), v(B, W.CenterVertical, [W.Top, W.Bottom]), B);
var et = (v(M = {}, F.Start, [F.End, F.Middle]), v(M, F.Middle, [F.End, F.Start]), v(M, F.End, [F.Start, F.Middle]), v(M, F.Fit, [F.Middle, F.Start, F.End]), M);
var nt,
  ot,
  rt,
  it,
  at = ["active", "spacing", "align", "justify", "adjustOnMutation", "children", "className", "popoverZIndex", "refEl", "usePortal", "portalClassName", "portalContainer", "scrollContainer"],
  ct = ["transform"],
  lt = a(nt || (nt = E(["\n  position: absolute;\n  transition: transform 150ms ease-in-out, opacity 150ms ease-in-out;\n  opacity: 0;\n"]))),
  st = {
    attributes: !0,
    characterData: !0,
    childList: !0,
    subtree: !0
  };
function ut(r) {
  var w = r.active,
    y = void 0 !== w && w,
    O = r.spacing,
    C = void 0 === O ? 10 : O,
    S = r.align,
    x = void 0 === S ? W.Bottom : S,
    D = r.justify,
    H = void 0 === D ? F.Start : D,
    R = r.adjustOnMutation,
    V = void 0 !== R && R,
    T = r.children,
    B = r.className,
    M = r.popoverZIndex,
    z = r.refEl,
    N = r.usePortal,
    k = void 0 === N || N,
    Z = r.portalClassName,
    U = r.portalContainer,
    X = r.scrollContainer,
    Y = P(r, at),
    $ = j(e(null), 2),
    q = $[0],
    G = $[1],
    J = j(e(null), 2),
    K = J[0],
    Q = J[1],
    _ = j(e(0), 2),
    tt = _[0],
    et = _[1],
    nt = s(),
    ut = nt.portalContainer,
    ft = nt.scrollContainer;
  ut = U || ut, ft = X || ft, k && ft && (ft.contains(ut) || g.warn("To ensure correct positioning make sure that the portalContainer element is inside of the scrollContainer"));
  var pt = t.useRef(K);
  pt.current = K;
  var dt = null;
  if (z && z.current) dt = z.current;else if (q) {
    var ht = q.parentNode;
    ht && ht instanceof HTMLElement && (dt = ht);
  }
  var gt = u(),
    mt = V && y,
    wt = f(dt, st, Date.now, mt),
    yt = f(K, st, Date.now, mt),
    vt = p(I(dt, ft)),
    bt = p(I(K, ft)),
    Pt = p(n(function () {
      return A(dt, ft);
    }, [dt, ft, gt, wt, y, x, H, tt])),
    Et = p(n(function () {
      return A(K);
    }, [K, gt, yt, y, x, H, tt])),
    jt = d(H),
    Ot = d(x),
    Ct = jt !== H && (H === F.Fit || jt === F.Fit) || Ot !== x && H === F.Fit;
  h(function () {
    Ct && et(function (t) {
      return t + 1;
    });
  }, [Ct]);
  var St = j(e(!1), 2),
    xt = St[0],
    Dt = St[1];
  if (h(function () {
    return Dt(!0);
  }, []), !xt) return null;
  var Ht,
    Rt = L({
      useRelativePositioning: !k,
      spacing: C,
      align: x,
      justify: H,
      referenceElViewportPos: vt,
      referenceElDocumentPos: Pt,
      contentElViewportPos: bt,
      contentElDocumentPos: Et,
      scrollContainer: ft
    }),
    Vt = Rt.align,
    Tt = Rt.justify,
    Bt = Rt.positionCSS,
    Mt = Bt.transform,
    Wt = P(Bt, ct),
    Ft = a(ot || (ot = E(["\n    opacity: 1;\n    position: ", ";\n    pointer-events: initial;\n  "])), k ? "" : "absolute"),
    Lt = k ? l : o,
    zt = k ? ut ? {
      container: ut
    } : {
      className: null != Z ? Z : void 0
    } : {};
  return Ht = null == T ? null : "function" == typeof T ? T({
    align: Vt,
    justify: Tt,
    referenceElPos: Pt
  }) : T, m(i, {
    nodeRef: pt,
    in: y,
    timeout: 150,
    mountOnEnter: !0,
    unmountOnExit: !0,
    appear: !0
  }, function (e) {
    var n;
    return m(t.Fragment, null, m("div", {
      ref: G,
      className: a(rt || (rt = E(["\n              display: none;\n            "])))
    }), m(Lt, zt, m("div", b({}, Y, {
      className: c(lt, a(Wt), (n = {}, v(n, a({
        transform: Mt
      }), "entering" === e || "exiting" === e), v(n, Ft, "entered" === e), v(n, a(it || (it = E(["\n                    z-index: ", ";\n                  "])), M), "number" == typeof M), n), B)
    }), m("div", {
      ref: Q
    }, Ht))));
  });
}
ut.displayName = "Popover", ut.propTypes = {
  children: r.oneOfType([r.node, r.func]),
  active: r.bool,
  className: r.string,
  align: r.oneOf(Object.values(W)),
  justify: r.oneOf(Object.values(F)),
  refEl: r.shape({
    current: "undefined" != typeof window ? r.instanceOf(Element) : r.any
  }),
  usePortal: r.bool,
  portalClassName: r.string,
  spacing: r.number,
  adjustOnMutation: r.bool
};
export { W as Align, F as Justify, ut as default };